<script setup>
import {APP} from "@/config/app";

defineProps({
  value: String,
  spanClass: {
    type: String,
    default: ''
  }
});
</script>

<template>
  <label class="block cursor-pointer body-1-reg text-off-black mb-1">
    <span v-if="value" :class="spanClass ?? ''">{{ value }}</span>
    <span v-else :class="spanClass ?? ''"><slot /></span>
  </label>
</template>
